import { render, staticRenderFns } from "./sdMappingDetail.vue?vue&type=template&id=bf8e4fba&scoped=true"
import script from "./sdMappingDetail.vue?vue&type=script&lang=js"
export * from "./sdMappingDetail.vue?vue&type=script&lang=js"
import style0 from "./sdMappingDetail.vue?vue&type=style&index=0&id=bf8e4fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8e4fba",
  null
  
)

export default component.exports